module.exports = __webpack_public_path__ + "img/replenishment_for_bundle_products.c08ec47b.svg";